import { render, staticRenderFns } from "./ListArchive.vue?vue&type=template&id=95709532&scoped=true&"
import script from "./ListArchive.vue?vue&type=script&lang=js&"
export * from "./ListArchive.vue?vue&type=script&lang=js&"
import style0 from "./ListArchive.vue?vue&type=style&index=0&id=95709532&lang=scss&scoped=true&"
import style1 from "./ListArchive.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95709532",
  null
  
)

export default component.exports